// src/app/modules/AccessControl/pages/access-logs-table/column-formatters/DestinationColumnFormatter.jsx
// Adaptive formatter for destination (host/department/area)

import React from "react";
import { MapPin, Building2, Users } from 'lucide-react';

function Row({ Icon, bg, color, title, sub }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <div style={{
        width: 28, height: 28, borderRadius: '50%', flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: bg, color,
      }}>
        <Icon size={14} />
      </div>
      <div>
        <div style={{ fontWeight: 600, fontSize: 13.5 }}>{title}</div>
        {sub && <div className="sety-tbl-sub">{sub}</div>}
      </div>
    </div>
  );
}

export function DestinationColumnFormatter(cellContent, row, getLabel) {
  if (row.log_type === 'staff_shift') {
    if (!row.space_name && !row.department) return <span className="sety-tbl-sub">—</span>;
    return (
      <Row Icon={Building2} bg="#EFF6FF" color="#2563EB"
        title={row.department || row.space_name}
        sub={row.shift_type ? `${row.shift_type} shift` : null}
      />
    );
  }

  if (row.log_type === 'resident_access') {
    return (
      <Row Icon={MapPin} bg="#F0FDF4" color="#16a34a"
        title={row.space_name || 'Main Entrance'}
        sub={row.vehicle_plate}
      />
    );
  }

  if (!row.host_name) return <span className="sety-tbl-sub">—</span>;

  return (
    <Row Icon={Users} bg="#F0EEFF" color="#5046D6"
      title={row.host_name}
      sub={row.space_name}
    />
  );
}
